import { API } from 'aws-amplify';

export function getAllPromo() {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', '/discount-codes');
}

export function createPromo(code) {
  return API.post('party', '/discount-codes', { body: code });
}

export function updatePromo(code) {
  return API.put('party', '/discount-codes', { body:code});
}
